<template lang="pug">
  div(v-if = 'storeFetch == false')
    .store-location-loader
        .loader-spinner
  div(v-else)
    .store-location(v-if='store')
      .store-detail.row
        .col-lg-8
          img.map(:src='store.attributes["map-url"]')
        .col-lg-4
          .store-details-item.store-details-item-bold(v-text='getStoreName(store)')
          .store-details-item(v-html='replaceNewLineParamterWithBrTag(store)')
          .store-details-item(v-text='`${$t("bookingService.phone")}: ${store.attributes.phone}`')
          .store-details-item.store-message(v-html='store.attributes["store-message"]')
          .store-details-item.hours-container
            .hours(v-for='weekdayHours in coalesceHours(store)'  v-text='weekdayHours')
          div
            a.direction(v-text='$t("bookingService.getDirections")' :href='directionUrl' target='_blank')
      .tabs-container
        ul.nav.nav-tabs.nav-tabs-primary(role='tablist')
          li.nav-item
            a.nav-link.active.ga-olr-store-tab(
              data-toggle='tab'
              href='#beauty-services'
              role='tab'
              @click='onTabChange("#beauty-services")'
              v-t='"retailStore.services"'
            )
          li.nav-item
            a.nav-link.ga-olr-store-tab(
              data-toggle='tab'
              href='#beauty-classes'
              role='tab'
              @click='onTabChange("#beauty-classes")'
              v-if='beautyClasses.length !== 0'
              v-t='"retailStore.classes"'
            )
          li.nav-item
            a.nav-link.ga-olr-store-tab(
              data-toggle='tab'
              href='#store-events'
              role='tab'
              @click='onTabChange("#store-events")'
              v-t='"retailStore.events"'
            )

          .tab-track
            .bar

      .tab-content.tab-content-primary
        .tab-pane.active#beauty-services(role='tabpanel')
          CategoryServices(v-for='category in filteredCategories' :key='category.id' :category='category' :services='getServiceByCategory(category)' :store='store')
          .empty-view(v-if='categories.length===0' v-text='$t("bookingService.empty")')
        .tab-pane#beauty-classes(v-if='beautyClasses.length!==0' role='tabpanel')
          BeautyClasses(:beauty-classes='beautyClasses' :store='store')
          .empty-view(v-if='beautyClasses.length===0' v-text='$t("bookingService.empty")')
        .tab-pane#store-events(role='tabpanel')
          Events(:events='storeEvents' :store='store')
          .empty-view(v-if='storeEvents.length===0' v-text='$t("bookingService.empty")')
</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "metaDescription": "Visit Sephora {area} in {city}, {country}. Discover outlet information, join in our store events, sign up for beauty services, and more now!",
      "getDirections": "Get directions",
      "empty": "There are currently no store events. Please check back soon.",
      "flagship": "FLAGSHIP",
      "phone": "Phone",
      "storeNotAvailable": "Store not available!"
    }
  },
  "lng_zh": {
    "bookingService": {
      "metaDescription": "Visit Sephora {area} in {city}, {country}. Discover outlet information, join in our store events, sign up for beauty services, and more now!",
      "getDirections": "Get directions",
      "empty": "There are currently no store events. Please check back soon.",
      "flagship": "FLAGSHIP",
      "phone": "Phone",
      "storeNotAvailable": "無此分店!"
    }
  },
  "lng_th": {
    "bookingService": {
      "metaDescription": "Visit Sephora {area} in {city}, {country}. Discover outlet information, join in our store events, sign up for beauty services, and more now!",
      "getDirections": "ดูเส้นทาง",
      "empty": "ยังไม่มีกิจกรรมที่สาขาในตอนนี้ โปรดกลับมาดูอีกครั้งในเร็ว ๆ นี้",
      "flagship": "FLAGSHIP",
      "phone": "Phone",
      "storeNotAvailable": "ไม่มีสาขานี้"
    }
  },
  "lng_id": {
    "bookingService": {
      "metaDescription": "Visit Sephora {area} in {city}, {country}. Discover outlet information, join in our store events, sign up for beauty services, and more now!",
      "getDirections": "Get directions",
      "empty": "There are currently no store events. Please check back soon.",
      "flagship": "FLAGSHIP",
      "phone": "Phone",
      "storeNotAvailable": "Toko tidak tersedia"
    }
  },
  "lng_ko": {
    "bookingService": {
      "metaDescription": "{country} {city} Sephora {area}점을 방문하세요. 지금 매장 소식을 확인하고, 매장 이벤트에 참여하거나 뷰티 서비스를 신청해보세요! ",
      "getDirections": "오시는 길",
      "empty": "현재 진행 중인 매장 이벤트가 없습니다. 나중에 다시 확인해주세요. ",
      "flagship": "플래그쉽",
      "phone": "전화번호",
      "storeNotAvailable": "죄송합니다. 현재 매장을 불러올 수 없습니다."
    }
  }
}
</i18n>
<script>
import StoreMixin from './store-mixin'
import CategoryServices from './reusable/category-services.vue'
import BeautyClasses from './reusable/beauty-classes.vue'
import Events from './reusable/events.vue'
import { fullUrl } from '@/modules/services/utilities'
import { setCookie } from '@/modules/services/cookies'
import { createNamespacedHelpers } from 'vuex'
 const { mapActions, mapGetters, mapState } = createNamespacedHelpers('bookingService')

export default {
  name: 'StoreLocationShow',
  components: {
    CategoryServices,
    BeautyClasses,
    Events
  },
  mixins: [StoreMixin],
  data () {
    return {
      filteredCategories: [],
      isPageLoaded: false,
      storeEvents: [],
      storeFetch: false,
      storeServices: [],
      storeClasses: []
    }
  },
  computed: {
    ...mapGetters(['objectById']),
    ...mapState(['categories', 'stores', 'events', 'services', 'beautyClasses']),
    store () {
      let store
      if (this.stores.length > 0) {
        store = this.objectById('stores', this.storeId)
        if (!store) {
          throw 'Invalid store.' // eslint-disable-line no-throw-literal
        }
      }

      return store
    },
    storeId () {
      return this.$route.params['id']
    },
    storeCode () {
      return this.store.attributes['store-code']
    },
    directionUrl () {
      const { latitude, longitude } = this.store.attributes
      return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`
    }
  },
  created () {
    this.storeInCookies()
  },
  watch: {
    storeId (newVal) {
      if (newVal) {
        this.filteredCategories = []
        this.storeFetch = false
        this.fetchStore(newVal).then(() => {
          this.setStoreServices()
          this.setFilteredCategories()
          this.setStoreEvents()
          this.setStoreClasses()
          this.setStoreTab()
          this.storeFetch = true
        })
      }
    },
    store: {
      handler (newVal) {
        this.storeLocationIdInCookie()
        this.$store.commit('setSeoMetaTitle', `Sephora ${newVal.attributes.name}`)
        this.$store.commit(
          'setSeoMetaDescription',
          this.$t('bookingService.metaDescription', {
            area: newVal.attributes.name,
            city: newVal.attributes.city,
            country: newVal.attributes.country.name
          })
        )
        this.$store.commit('setSeoUpdate', true)
        this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
        // if (!this.$route.hash) {
        //   this.$scrollTo('#header', 200)
        // }
      },
      immediate: true
    }
  },
  // mounted () {
  //   this.fetchStore(this.storeId).then(() => {
  //     // const storeCode = this.store['attributes']['store-code']
  //     this.setStoreTab()
  //     this.setStoreEvents()
  //     // this.setBeautyClasses()
  //   }).catch(e => {
  //     this.$store.commit('setNotification', {
  //       type: 'error',
  //       msg: this.$t('bookingService.storeNotAvailable')
  //     })
  //     this.$router.push({ name: 'store-location-index' })
  //   })
  // },
  beforeMount () {
    this.filteredCategories = []
    this.fetchStore(this.storeId).then(() => {
      this.setStoreServices()
      this.setFilteredCategories()
      this.setStoreEvents()
      this.setStoreClasses()
      this.setStoreTab()
      this.storeFetch = true
    }).catch(e => {
      this.$store.commit('setNotification', {
        type: 'error',
        msg: this.$t('bookingService.storeNotAvailable')
      })
      this.$router.push({ name: 'store-location-index' })
    })
  },
  methods: {
    ...mapActions(['fetchStore', 'fetchEvents', 'fetchBeautyClasses']),
    storeLocationIdInCookie () {
      const params = this.store.attributes['timetrade-location-id']
      const expiryTime = new Date(Date.now() + 5 * 60 * 1000)
      setCookie('locationId', params, expiryTime, '/')
    },
    setStoreEvents () {
      this.fetchEvents(this.storeCode).then(() => {
        this.storeEvents = this.events.filter(event => event.attributes['status'] === 'published')
      })
    },
    setStoreServices () {
      this.storeServices = this.services
    },
    setStoreClasses () {
      this.fetchBeautyClasses(this.storeCode).then(() => {
        this.storeClasses = this.beautyClasses.filter(beautyClass => beautyClass.attributes['status'] === 'published')
      })
    },
    onTabChange (href) {
      this.$router.replace({ hash: href })
    },
    includedCategories () {
      return this.categories.filter(category =>
        !(
          (category.attributes['booking-vendor'] === 'In House' &&
          category.attributes['cutover-from'] === null &&
          category.attributes['cutover-till'] === null) ||
          category.attributes['activity-type'] !== 'Service'
        ) && category.attributes['status'] === 'published'
      )
    },
    setFilteredCategories () {
      const includeCategories = this.includedCategories()

      for (let i = 0; i < this.storeServices.length; i++) {
        for (let j = 0; j < this.storeServices[i]['attributes']['activity-groups'].length; j++) {
          const activityGroupId = this.storeServices[i]['attributes']['activity-groups'][j]['id'].toString()

          if (this.filteredCategories.some(x => x.id === activityGroupId)) {
            continue
          }

          const val = includeCategories.find(category => category.id === activityGroupId)
          if (typeof val !== 'undefined') {
            this.filteredCategories.push(val)
          }
        }
      }
    },
    getServiceByCategory (category) {
      return this.services.filter(service => {
        return service.attributes['status'] === 'published' &&
          service.attributes['activity-groups'].some(activityGroup => {
            return activityGroup.id === +category.id
          })
      })
    },
    setStoreTab () {
      if (this.$route.hash === '#store-events') {
        $(`a[href="#store-events"]`).tab('show')
      } else if (this.$route.hash === '#beauty-classes') {
        $(`a[href="#beauty-classes"]`).tab('show')
      } else {
        $(`a[href="#beauty-services"]`).tab('show')
      }

      // if (this.$route.hash) {
      //   this.$scrollTo(this.$route.hash, 200, {
      //     offset: -110
      //   })
      // }
    },
    replaceNewLineParamterWithBrTag (store) {
      return store.attributes['address'].replace(/\n/g, '<br />')
    }
  }
}
</script>

<style scoped lang='scss'>
  .store-location {
    @include media-breakpoint-down(md) {
      padding-right: 5px;
      padding-left: 5px;
    }
  }

  .store-location-loader{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  .store-details-item-bold {
    @include font-weight-bold;
  }

  .direction {
    text-transform: uppercase;
    font-weight: bold;
    text-decoration: underline;
  }

  .store-details-item {
    line-height: 18px;
    margin-bottom: 20px;
  }

  .map {
    max-width: 100%;

    @include media-breakpoint-down(sm) {
      margin-bottom: 20px;
    }

    @include media-breakpoint-up(md) {
      height: 365px;
    }
  }

  .tabs-container {
    margin-top: 20px;
  }
</style>
